var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentComponent,{tag:"component",attrs:{"queries":this.$route.query}})}
var staticRenderFns = []

export { render, staticRenderFns }